import React, { useEffect } from "react";
import styled, { css } from "styled-components";
import { toast } from "react-toastify";
import _ from "lodash";

import Grid from "src/library/components/Hedron";
import { Button } from "src/library/components/Button";
import { TabbedNavigation } from "src/library/components/TabbedNavigation";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import ImportOrdersPageTab from "src/pages/Admin/Orders/ImportOrdersPageTab";
import {
  useOrderImportApi,
  OrderImportRequestName
} from "src/modules/order-import/api/order-import.api";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";

const ImportOrdersPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const [ importOrderSettingsRes, importOrderSettingsReq ] = useOrderImportApi(OrderImportRequestName.LIST_ORDER_IMPORT_SETTINGS);

  // fetch all available order import settings
  useEffect(() => {
    importOrderSettingsReq(null);
  }, [ importOrderSettingsReq ]);

  const tabs = React.useMemo(() => {
    if (importOrderSettingsRes.error) {
      toast.error(importOrderSettingsRes.error.message);
    }

    if (importOrderSettingsRes.data) {
      // loop to generate tab options props
      return importOrderSettingsRes.data.map(setting => ({
        title: _.startCase(_.toLower((setting.name).replace(/[^a-zA-Z\s]/g, " "))),
        content: () => (
          <ImportOrdersPageTab
            orderType={setting.name}
            history={props.history}
          />
        )
      }));
    }

    return [];
  }, [ props.history, importOrderSettingsRes ]);

  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        <Grid.Bounds direction="horizontal">
          <ButtonWrapper>
            <Button onClick={() => props.history.push("/admin/orders/imports/new")}>
              Import Orders
            </Button>
          </ButtonWrapper>
        </Grid.Bounds>

        <ImportOrdersWrapper>
          {importOrderSettingsRes.pending && <LoadingSpinner type="circular" />}

          <TabbedNavigation tabs={tabs} />
        </ImportOrdersWrapper>
      </MainContentWrapper>
    </Layout>
  );
};

const ImportOrdersWrapper = styled(Grid.Box)`
  margin-top: ${({ theme }) => theme.spacing.margins.lg};
`;

const ButtonWrapper = styled(Grid.Box)`
  ${({ theme }) => css`
    margin-right: ${theme.spacing.margins.sm};
  `}
`;

export default ImportOrdersPage;
